const initials = "question-add/";

export const UPDATE_QUESTION = `${initials}UPDATE_QUESTION`;
export const UPDATE_SYLLABUS = `${initials}UPDATE_SYLLABUS`;
export const UPDATE_SUBJECT = `${initials}UPDATE_SUBJECT`;
export const UPDATE_SESSION = `${initials}UPDATE_SESSION`;
export const UPDATE_COURSE = `${initials}UPDATE_COURSE`;